/**
 * @tabler/icons-react v2.47.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconGymnastics = createReactComponent("gymnastics", "IconGymnastics", [
  ["path", { d: "M7 7a1 1 0 1 0 2 0a1 1 0 0 0 -2 0", key: "svg-0" }],
  ["path", { d: "M13 21l1 -9l7 -6", key: "svg-1" }],
  ["path", { d: "M3 11h6l5 1", key: "svg-2" }],
  ["path", { d: "M11.5 8.5l4.5 -3.5", key: "svg-3" }]
]);

export { IconGymnastics as default };
//# sourceMappingURL=IconGymnastics.js.map
